import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['accounting-categories']);

export const accountingCategoriesQueryKeys = {
  all: builder(),
  one: (id: number) => builder('one', id),
};
